import Css from './Css'
import vImag from '../Images/function_vibration.png';
import TimeFormat from '../Utils/TimeFormat.js';
import { useTranslation } from 'react-i18next';

function VibrationBox(props){
  const { t } = useTranslation();
  const {videoEl,leftWidth} = props.data;
  const {mouseMoveToVibrationBoxArea} = props.method;
  let videoPregress = parseInt(videoEl.currentTime*1000);
  let time = TimeFormat(videoPregress, 'HH:mm:ss.x');

  const mouseEnterVibrationBox = (e) => {
    if(e.buttons === 1){ //鼠标左键按下进入左侧VibrationBox组件区域
      setTimeout(()=>{
        mouseMoveToVibrationBoxArea();
      },20);
    }
  }

  return (
    <>
      <div style={ Css.vibrationBox(leftWidth) }>
        <div style={ Css.vTimeArea(leftWidth) }>
          {time}
        </div>
        <div onMouseEnter={ (e)=>{ mouseEnterVibrationBox(e) } } style={ Css.lsArea(leftWidth) }>
          <img style={ Css.vImag(leftWidth) } src={ vImag } alt=""></img>
          <div style={ Css.lsArea(leftWidth).txt }>{t("vibration")}</div>
        </div>
      </div>
    </>
  )
}

export default VibrationBox;